import { Box, Link } from "@chakra-ui/react"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import PropTypes from "prop-types"
import { AudioButtonUI } from "./ui"

export const DownloadButton = ({ source }: { source: string }) => {
  source = source.includes("filestackcontent") ? `${source}?dl=true` : source

  return (
    <Box width="55px" m="0px">
      <Link
        href={source}
        target="_blank"
        rel="noopener noreferrer"
        download={true}
      >
        <AudioButtonUI
          height="40px"
          width="50px"
          aria-label="Download"
          children={<Pathicon icon="download" size="24px" />}
        />
      </Link>
    </Box>
  )
}

DownloadButton.propTypes = {
  source: PropTypes.string.isRequired
}

export default DownloadButton
